// Port of api/fuel/app/classes/filter/package/games/play/data/plays/group.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	require: function(config) { return config.ownerType !== F.OWNER_USER },
	run: function(filter, data, config, global) {
		global.plays = global.plays || {}
		global.plays.group = {
			all: {},
			context: {}
		}
		if (!global.gameIds || !global.gameIds.length || !global.userIndex.length) return

		var allRows = DB.query(
			'SELECT game_id AS game, SUM(play_count) AS count, SUM(play_length) AS minutes FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ') GROUP BY game_id'
		)
		for (var i = 0; i < allRows.length; i++) {
			global.plays.group.all[allRows[i].game] = allRows[i]
		}

		if (filter.played && filter.played.range && (filter.played.range.from || filter.played.range.to)) {
			var where = ['game_id IN(' + Util.in(global.gameIds) + ')', 'user_id IN(' + Util.in(global.userIndex) + ')']
			if (filter.played.range.from) where.push('play_date >= ' + parseInt(filter.played.range.from, 10))
			if (filter.played.range.to) where.push('play_date <= ' + parseInt(filter.played.range.to, 10))

			var contextRows = DB.query(
				'SELECT game_id AS game, SUM(play_count) AS count, SUM(play_length) AS minutes FROM play WHERE ' + where.join(' AND ') + ' GROUP BY game_id'
			)
			for (var j = 0; j < contextRows.length; j++) {
				global.plays.group.context[contextRows[j].game] = contextRows[j]
			}
		} else {
			global.plays.group.context = global.plays.group.all
		}
	}
}
